/**
 * Created by Viacheslav Stepanian on 15.09.2026
 */

const MiniPromo = function () {
    this.load();
};

MiniPromo.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.MINI_PROMO) || {};

    this.closedDate = data.closedDate || 0;
};

MiniPromo.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.MINI_PROMO, { closedDate: this.closedDate });
};

MiniPromo.prototype.reset = function () {
    this.load();
};

MiniPromo.prototype.isAvailable = function () {
    return Boolean(cleverapps.crossPromo
        && cleverapps.crossPromo.isAvailable()
        && cleverapps.user.checkAvailable(cleverapps.config.availables.MINI_PROMO)
        && cleverapps.abExperiments.isInitialized()
        && cleverapps.abExperiments.getGroup(ABExperiments.Tests.minipromo) === "A"
        && this.listPromotions().length);
};

MiniPromo.prototype.needShow = function () {
    return this.isAvailable() && !this.isClosed();
};

MiniPromo.prototype.isClosed = function () {
    return Boolean(this.closedDate) && Date.now() - this.closedDate < MiniPromo.HIDE_INTERVAL;
};

MiniPromo.prototype.close = function () {
    this.closedDate = Date.now();

    this.save();
};

MiniPromo.prototype.findView = function () {
    return ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), MiniPromo.CONTROL);
};

MiniPromo.prototype.findToolbarIcon = function () {
    const item = cleverapps.toolbar && cleverapps.toolbar.getItem(ToolbarItem.MINI_PROMO.type);

    return item && item.isVisible() ? item.onGetView() : undefined;
};

MiniPromo.prototype.show = function (scene) {
    if (this.findView()) {
        return;
    }

    scene = scene || cleverapps.Scenes.GetRunningScene();
    scene.addChild(Prefab.instantiate(bundles.mini_promo.jsons.minipromo_prefab_json));
};

MiniPromo.prototype.toggle = function () {
    const view = this.findView();

    if (!view) {
        this.show();
        return;
    }

    const controller = ComponentUtils.findComponentByName(view, "MiniPromoController");

    if (controller) {
        controller.onClosePressed();
    }
};

MiniPromo.prototype.getToolbarIcon = function () {
    return bundles.toolbar.frames.toolbar_mini_promo_icon_png;
};

MiniPromo.prototype.getIcon = function (game) {
    return bundles.mini_promo && bundles.mini_promo.frames[`promo_${game}`];
};

MiniPromo.prototype.listPromotions = function () {
    const games = cleverapps.crossPromo.listTopGames().filter((game) => this.getIcon(game));

    const promotions = [];

    for (let i = 0; i < games.length && promotions.length < MiniPromo.AMOUNT; ++i) {
        const promotion = cleverapps.crossPromo.createPromotion(games[i]);

        if (promotion) {
            promotion.icon = this.getIcon(games[i]);
            promotions.push(promotion);
        }
    }

    return promotions;
};

MiniPromo.VARIANTS = ["deal", "genie", "arc", "swing", "elastic", "radial"];
MiniPromo.VARIANT = "deal";

MiniPromo.BUNDLE = "mini_promo";
MiniPromo.CONTROL = "mini_promo";
MiniPromo.AMOUNT = 3;
MiniPromo.HIDE_INTERVAL = cleverapps.parseInterval(cleverapps.config.debugMode ? "10 minutes" : "3 days");

cleverapps.InitByFeature["mini_promo"] = function () {
    cleverapps.miniPromo = new MiniPromo();

    cleverapps.eventBus.on("userChanged", () => {
        cleverapps.miniPromo.reset();
    });
};
